import Reveal from '../../../shared/Reveal/Reveal';
import './Hero.css';

const Hero = ({ category, title, excerpt, image }) => {
  return (
    <section className="market-analysis-details-hero">
      <div className="market-analysis-details-hero__inner">
        <Reveal className="market-analysis-details-hero__copy">
          <p className="market-analysis-details-hero__tag">{category}</p>
          <h1 className="market-analysis-details-hero__title">{title}</h1>
          <p className="market-analysis-details-hero__text">{excerpt}</p>
        </Reveal>

        <Reveal className="market-analysis-details-hero__media" delay={80}>
          <img
            className="market-analysis-details-hero__image"
            src={image}
            alt=""
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
